<div id="mainBody" class="divBody">

  <div id="carouselDiv">
    <app-carousel></app-carousel>
  </div>

</div>

